import React from 'react';
import { Col, FormGroup, Label, Input, Row } from 'reactstrap';
import { H5, Image } from 'AbstractElements';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import PostCommon from 'Component/Common/Form/Post';
import DropzoneCommon from 'Component/Common/Upload/Dropzone';
import { submitTreatment } from 'Services/Features/Treatment/Utils/treatmentUtils';
import { setFormData, resetFormData } from 'Services/Features/Treatment/treatmentSlice';
import CustomLoader from 'Component/Common/CustomLoader';
import CarouselPhotosTreatment from '../CarouselPhotosTreatment';
import MultipleInput from './MultipleInput';
import SelectCategory from './SelectCategory';
import { formatPrice } from 'Component/DashboardQeza/Common/PriceUtils';

const TreatmentForm = ({ label, setRefetch }) => {
    const dispatch = useDispatch();
    const history = useNavigate();
    const data = useSelector(state => state.treatment.currentTreatment)
    const startUpload = useSelector(state => state.treatment.loading);

    const handleSuccess = () => {
        dispatch(resetFormData());
        history(`${process.env.PUBLIC_URL}/treatments`);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(submitTreatment({ ...data, successCallback: handleSuccess }))
    };

    const handleDiscard = (e) => {
        e.preventDefault();
        dispatch(resetFormData());
        history(`${process.env.PUBLIC_URL}/treatments`);
    };

    const handlePriceChange = (e) => {
        const rawValue = e.target.value.replace(/\./g, ""); // Hilangkan titik untuk dapatkan angka asli
        const { name } = e.target;
        if (!isNaN(rawValue)) {
            handleChanges({ target: { name: name, value: rawValue } });
        }
    };

    const handleChanges = (e) => {
        const { name, value } = e.target;
        dispatch(setFormData({ [name]: value }));
    }

    const handleChangePhotos = ({ meta, file }, status) => {
        if (status === 'done') {
            dispatch(setFormData({ 'photos': [...data.photos, file] }));
        } else if (status === 'removed') {
            dispatch(setFormData({ 'photos': data.photos.filter((photo) => photo !== file) }));
        }
    };


    return (
        <PostCommon title={label} handleSubmit={handleSubmit} handleDiscard={handleDiscard} >
            {startUpload && (
                <CustomLoader />
            )}
            <div>
                <Row className="mb-3">
                    <Col sm={6}>
                        <FormGroup className='mb-3'>
                            <Label for="validationName" style={{ fontWeight: 'bold' }}>Nama :</Label>
                            <Input
                                className="form-control"
                                id="validationName"
                                type="text"
                                name="name"
                                placeholder="Masukkan nama layanan perawatan..."
                                required=""
                                value={data.name}
                                onChange={handleChanges}
                            />
                        </FormGroup>
                    </Col>
                    <Col sm={6}>
                        <FormGroup className='mb-3'>
                            <Label for="validationCategoyId" style={{ fontWeight: 'bold' }}>Kategori :</Label>
                            <SelectCategory />
                        </FormGroup>
                    </Col>
                    <Col sm={6}>
                        <FormGroup className='mb-3'>
                            <Label for="validationPrice" style={{ fontWeight: 'bold' }}>Biaya :</Label>
                            <Input className="form-control" id="validationPrice" type="text" onWheel={(e) => e.target.blur()} name="price" placeholder="Masukkan biaya perawatan..." required=""
                                onKeyDown={(e) => {
                                    if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                        e.preventDefault();
                                    }
                                }}
                                value={formatPrice(data.price)}
                                onChange={handlePriceChange} />
                        </FormGroup>
                    </Col>
                    <Col sm={6}>
                        <FormGroup className='mb-3'>
                            <Label for="validationGimmicPrice" style={{ fontWeight: 'bold' }}>Harga Coret :</Label>
                            <Input className="form-control" id="validationGimmicPrice" type="text" onWheel={(e) => e.target.blur()} name="gimmick_price" placeholder="Masukkan biaya perawatan..." required=""
                                onKeyDown={(e) => {
                                    if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                        e.preventDefault();
                                    }
                                }}
                                value={formatPrice(data.gimmick_price)}
                                onChange={handlePriceChange} />
                        </FormGroup>
                    </Col>
                    <Col sm={12}>
                        <FormGroup className='mb-3'>
                            <Label for="validationBenefits" style={{ fontWeight: 'bold', display: 'block' }}>
                                Manfaat Perawatan :
                                <span style={{ fontSize: '12px', fontStyle: 'italic', fontWeight: 'normal', color: '#6c757d', display: 'block' }}>
                                    Deskripsi singkat tentang manfaat yang akan didapatkan dari perawatan ini.
                                </span>
                            </Label>
                            <MultipleInput 
                                name="benefits"
                                initialData={data.benefits}
                                placeholder="Manfaat perawatan"
                                onChange={(name, value) => dispatch(setFormData({ [name]: value }))} 
                            />
                        </FormGroup>
                    </Col>
                    <Col sm={12}>
                        <FormGroup className='mb-3'>
                            <Label for="validationProcess" style={{ fontWeight: 'bold', display: 'block' }}>
                                Proses Perawatan :
                                <span style={{ fontSize: '12px', fontStyle: 'italic', fontWeight: 'normal', color: '#6c757d', display: 'block' }}>
                                    Langkah-langkah atau tahapan yang akan dilakukan selama perawatan.
                                </span>
                            </Label>
                            <MultipleInput 
                                name="process"
                                initialData={data.process}
                                placeholder="Proses perawatan"
                                onChange={(name, value) => dispatch(setFormData({ [name]: value }))} 
                            />
                        </FormGroup>
                    </Col>
                    <Col sm={data.photosLink ? 12 : 6}>
                        <FormGroup className='mb-3'>
                            <Label for="validationDescription" style={{ fontWeight: 'bold' }}>Deskripsi Layanan :</Label>
                            <Input className="form-control" id="validationDescription" type="textarea" name="description" placeholder="Masukkan deskripsi layanan perawatan..." required=""
                                value={data.description}
                                onChange={handleChanges} 
                                style={{ height: data.id ? '200px' : '120px', overflow: 'scroll' }}
                                onInput={(e) => {
                                    e.target.style.height = "auto";
                                    e.target.style.height = `${e.target.scrollHeight}px`;
                                }}/>
                        </FormGroup>
                    </Col>
                    {data.photosLink && data.photosLink.length > 1 && (
                        <CarouselPhotosTreatment slides={3} title='Preview Foto Perawatan' rtl={true} lazyLoad={false} autoplay={false} focusOnSelect={false} images={data.photosLink} setRefetch={setRefetch}/>
                    )}
                    {data.photosLink && data.photosLink?.length === 1 && (
                        <Col sm="4" className="mb-3">
                            <H5>Preview</H5>
                            <Image attrImage={{ className: 'img-fluid', src: data.photosLink[0]?.photo, alt: `${data.name}`, style: { height: '100%', objectFit: 'contain', borderRadius: '18px' } }} />
                        </Col>
                    )}
                    <Col sm={data.photosLink ? data.photosLink?.length === 1 ? 8 : 12 : 6}>
                        <DropzoneCommon
                            label={'Foto Layanan'}
                            inputContent={'Update foto layanan'}
                            handleChangeStatus={handleChangePhotos}
                            accept="image/*"
                            multiple={true}
                        />
                    </Col>
                </Row>
            </div>
        </PostCommon>
    );
};

export default TreatmentForm;